import React, { useEffect, useMemo } from 'react';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { useWebformContext } from '../../../../context/WebformContext';
import type { WebformWizardPage } from '../../types';
import Inner from './Inner';

export interface WebformAssessmentActionsProps {
  entity: ImmutableEntity<WebformWizardPage>;
  values: Record<string, any>;
  pages: Immutable.Map<string, string>;
  currentPage: string;
  onPreviousPage: () => void;
  onNextPage: () => void;
  handleSubmit: () => void;
}

const WebformAssessmentActions: React.FC<WebformAssessmentActionsProps> = (props) => {
  const {
    entity,
    values,
    pages: wizardPages,
    currentPage: currentWizardPage,
    onPreviousPage: onPreviousWizardPage,
    onNextPage: onNextWizardPage,
    handleSubmit,
  } = props;

  const { currentElement, updateCurrentPage } = useWebformContext();

  const showSubmitButton = useMemo(() => (
    currentWizardPage === wizardPages.last()
  ), [currentWizardPage, wizardPages]);

  const isNextButtonDisabled = useMemo(() => {
    if (currentElement === 'processed_text') {
      return false;
    }

    return !values[currentElement];
  }, [currentElement, values]);

  useEffect(() => {
    updateCurrentPage(currentWizardPage);
  }, [currentWizardPage, updateCurrentPage]);

  return (
    <Inner
      prevButtonLabel={entity.get('#wizard_prev__label')}
      isPrevButtonDisabled={currentWizardPage === wizardPages.first()}
      nextButtonLabel={entity.get('#wizard_next__label')}
      isNextButtonDisabled={isNextButtonDisabled}
      showSubmitButton={showSubmitButton}
      submitButtonLabel={entity.get('#submit__label')}
      onPreviousPage={onPreviousWizardPage}
      onNextPage={showSubmitButton ? handleSubmit : onNextWizardPage}
    />
  );
};

export default WebformAssessmentActions;
